import React, { useEffect } from "react";


import NavBar from "../components/common/navBar";
import Logo from "../components/common/logo";


import "./styles/404.css";

const Notfound = () => {
	useEffect(() => {
		document.title = "Page not found";
	}, []);

	return (
		<React.Fragment>
			<div className="not-found page-content">
				<NavBar />
				<div className="content-wrapper">
					<div className="notfound-logo-container">
						<div className="projects-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="notfound-container">
						<div className="notfound-message">
							<div className="notfound-title">
								No :(
							</div>
							<div className="not-found-message">
								Page not found.
								<br />
								
							</div>
							<a href="/" className="not-found-link">
								Home
							</a>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Notfound;
